import React, { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  FileInput,
  FileField,
  BooleanInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { Typography, Grid } from "@mui/material";
import { languageChoices, projectType } from "utils/options";
import { ActiveEditToolbar } from "../Partials/CustomComponents/ActiveSaveToolbar";
import { editTitle } from "customStyles/ra-custom-styles";
import { CustomFile, EmptyFiles } from "components/features/Partials/CustomComponents/CustomFile";
import CustomImage from "../Partials/CustomComponents/CustomImage";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const EditProjects = () => {
  const [filesToDelete, setFilesToDelete] = useState([]);
  const handleChange = id => {
    if (filesToDelete.includes(id)) {
      setFilesToDelete([...filesToDelete.filter(item => item !== id)]);
    } else {
      setFilesToDelete([...filesToDelete, id]);
    }
  };
  const transform = data => ({
    ...data,
    delete_files_ids: [...filesToDelete],
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });
  return (
    <Edit
      mutationMode="pessimistic"
      sx={editTitle}
      transform={transform}
    >
      <Typography sx={editTitle}>Редакция на проект </Typography>
      <SimpleForm toolbar={<ActiveEditToolbar />}>
        <Grid
          container
          spacing={5}
        >
          <Grid
            item
            xs={5}
          >
            <SelectInput
              label="Език"
              source="language"
              choices={languageChoices}
              fullWidth
              validate={required()}
            />
            <CustomDateInput
              label="Начална дата"
              source="starting_on"
            />
            <CustomDateInput
              label="До дата"
              source="ending_on"
            />
            <CustomDateInput
              label="Дата на публикуване"
              source="started_on"
              validate={required()}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={5}
          >
            <SelectInput
              label="Тип проект"
              source="project_type"
              validate={required()}
              choices={projectType}
              fullWidth
            />
            <TextInput
              label="№ Проект"
              source="project_number"
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextInput
              label="Програма"
              source="program"
              fullWidth
              multiline
            />
            <TextInput
              label="Заглавие на проекта"
              source="title"
              fullWidth
              multiline
            />

            <TextInput
              label="Общ бюджет "
              source="common_budget"
              fullWidth
            />
            <TextInput
              label="Бюджет на Български пощи"
              source="budget_of_bulgarian_posts"
              fullWidth
            />
            <TextInput
              label="Срок за изпълнение"
              source="deadline_for_implementations"
              fullWidth
            />
            <TextInput
              label="Ръководител на проекта"
              source="project_manager"
              fullWidth
            />
            <TextInput
              label="Партньори"
              source="partners"
              fullWidth
              multiline
            />
            <TextInput
              label="Фонд"
              source="fund"
              fullWidth
            />
            <TextInput
              label="Практиканти"
              source="participant"
              fullWidth
            />
            <RichTextInput
              label="Съдържание"
              source="content"
              fullWidth
            />
            <RichTextInput
              label="Допълнителна информация"
              source="additional_information"
              fullWidth
            />
            <CustomImage
              label={"Текуща снимка"}
              style={{
                maxHeight: "10rem",
                maxWidth: "100%",
                marginBottom: "2rem",
              }}
            />
            <ImageInput
              placeholder="Добавете снимка"
              label="Снимка"
              source="image"
              accept="image/*"
            >
              <ImageField
                source="src"
                title="title"
              />
            </ImageInput>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (formData.project_files?.length === 0) {
                  return <EmptyFiles />;
                } else {
                  return (
                    <CustomFile
                      data={formData.project_files}
                      handleChange={handleChange}
                      filesToDelete={filesToDelete}
                    />
                  );
                }
              }}
            </FormDataConsumer>
            <ArrayInput
              source="files"
              label="Файлове"
            >
              <SimpleFormIterator
                fullWidth
                disableReordering
              >
                <FileInput
                  placeholder="Кликнете за да добавите файл"
                  label="Файл"
                  source="file"
                  maxSize={54525952}
                >
                  <FileField
                    source="src"
                    title="title"
                  />
                </FileInput>
                <TextInput
                  label="Име на файла"
                  source="name"
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>

            <BooleanInput
              label="Скрита"
              source="is_hidden"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EditProjects;
